import discardSafeMailingListsOption from './actions/discardSafeMailingListsOption';
import saveSafeMailingListsOption from './actions/saveSafeMailingListsOption';
import SafeMailingListsFull from './components/SafeMailingListsFull';
import isSafeMailingListsOptionDirty from './utils/isSafeMailingListsOptionDirty';
import * as React from 'react';
var SafeMailingListsOption = {
    key: 'safeMailingLists',
    titleStringKey: 'optionTitle_safeMailingLists',
    searchTermsStringKey: 'optionTitle_safeMailingLists',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SafeMailingListsFull, null); },
        isDirty: isSafeMailingListsOptionDirty,
        onSave: saveSafeMailingListsOption,
        onDiscard: discardSafeMailingListsOption,
    },
};
export default SafeMailingListsOption;
//# sourceMappingURL=SafeMailingListsOption.js.map